export type OverlayAction = 'new-game' | 'close' | 'penalty-wheel'
export type ActionCallback = (action: OverlayAction) => void

/**
 * Full-screen bomb explosion overlay.
 * Uses visibility/opacity (not display) so CSS transitions fire correctly.
 * Mounts once on app init; shown/hidden via show()/hide().
 */
export class BombOverlay {
  private el: HTMLElement
  private onAction: ActionCallback

  constructor(onAction: ActionCallback) {
    this.onAction = onAction
    this.el = this.create()
    document.body.appendChild(this.el)
    this.bindEvents()
  }

  show(bombNumber: number): void {
    const numEl  = this.el.querySelector<HTMLElement>('.overlay__bomb-num')
    const subEl  = this.el.querySelector<HTMLElement>('.overlay__sub')
    const emoji  = this.el.querySelector<HTMLElement>('.overlay__emoji')

    if (numEl) numEl.textContent = String(bombNumber)
    if (subEl) subEl.textContent = `就是炸弹数字！本局结束`

    // Re-trigger shake animation on emoji by removing/re-adding class
    if (emoji) {
      emoji.classList.remove('overlay__emoji--animate')
      // Force reflow so the animation restarts
      void emoji.offsetWidth
      emoji.classList.add('overlay__emoji--animate')
    }

    this.el.classList.add('bomb-overlay--show')
  }

  hide(): void {
    this.el.classList.remove('bomb-overlay--show')
  }

  private create(): HTMLElement {
    const div = document.createElement('div')
    div.className = 'bomb-overlay'
    div.innerHTML = `
      <div class="bomb-overlay__card glass-panel">
        <span class="overlay__emoji">💥</span>
        <div class="overlay__title">💣 踩雷啦！</div>
        <div class="overlay__bomb-num">--</div>
        <div class="overlay__sub"></div>
        <div class="overlay__actions">
          <button class="btn btn--danger" data-action="new-game">🔁 再来一局</button>
          <button class="btn btn--ghost" data-action="penalty-wheel">惩罚转盘</button>
          <button class="btn btn--ghost" data-action="close">查看结果</button>
        </div>
      </div>`
    return div
  }

  private bindEvents(): void {
    this.el.addEventListener('click', (e) => {
      const btn = (e.target as HTMLElement).closest<HTMLElement>('[data-action]')
      if (!btn) return
      this.onAction(btn.dataset.action as OverlayAction)
    })
  }
}
